import { Injectable } from '@angular/core';
import { EmitterService } from '../../services/emitter.service';
import { PnpZimplerService } from '../../services/pnp-zimpler.service';
import { PoliciesVersionService } from '../../services/policies-version.service';
import { TranslateService } from '@ngx-translate/core';
import { language, txnState } from '../../shared/utility/config';
import { environment } from '../../../environments/environment';
import { Utility } from '../../shared/utility/utility';
import { UserDetailsService } from '../../services/user-details.service';
import { CountryDataService } from '../../services/country.service';
import { AjaxService } from '../../services/ajax.service';
import { BRITEPLAY_REQUEST_MIN_LOOP_COUNT, USER_DEFAULT_CURRENCY } from '../config/cashier.config';
import { BonusService } from '../../app-myaccount/bonuses/services/bonus.service';
import * as $ from 'jquery'
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class CashierCommonService {
  isUserLoggedIn;
  userProfileDetails;
  countryIP;
  langCode;
  transactionId;
  quickRegistereCalled;
  requestLoopCount = 0;
  requestCountForNewUser=0;
  isThirdPartyLoginCalled;
  constructor(private emitterService:EmitterService,
    private pnpZimplerService:PnpZimplerService, 
    private policyService:PoliciesVersionService,
    private bonusService:BonusService,
    private translationService: TranslateService,private utils:Utility,
    private userDetailsService:UserDetailsService,
    private countryService:CountryDataService,
    private ajaxService:AjaxService, private messageService:MessageService) {
      this.updateDefaultValues();
    }
    updateDefaultValues() {
      this.isUserLoggedIn = this.utils.isUserLoggedIn();
      this.userProfileDetails = this.userDetailsService.getUserProfileDetails();
      if (this.isUserLoggedIn && this.userProfileDetails) {
        this.countryIP = this.userProfileDetails["country"];
      } else {
        this.countryIP = this.countryService.IPCountry;
      }
      this.langCode = localStorage.getItem("langCode") ? localStorage.getItem("langCode") : "en";
    }
    getUserCurrency(){
      let currency = USER_DEFAULT_CURRENCY;
      if(this.isUserLoggedIn && this.userProfileDetails){
        currency = this.userProfileDetails.currency
      }
      return currency;
    }
    getBriteplayRequestObj(reuqestData) {
      this.updateDefaultValues();
      let transactionAmount = reuqestData.transactionAmount ? reuqestData.transactionAmount : 0;
      let txnType = reuqestData.txnType;
      let currency = this.userDetailsService.getUserCurrencyForCahier();
      let selectedBonus = this.bonusService.getEligibleBonusCode();
  
      let initRequestData: any = {
        amount: transactionAmount,
        countryCode: this.countryIP,
        currencyCode: currency,
        site: environment.site,
        siteDisplayName: environment.siteDisplayName,
        txnType: txnType,
        bonusCode: selectedBonus && selectedBonus["bonusCode"] ? selectedBonus["bonusCode"]: "",
      };
      initRequestData = this.getRedirectionUrls(initRequestData);
  
      initRequestData.osBrowserType = this.utils.getOsBrowserType();
      initRequestData.channelId = this.utils.isMobile() ? "Mobile" : "Web";
      initRequestData.subChannel = this.utils.isMobile() ? "native" : "HTML";
      initRequestData = this.setUserLanguage(initRequestData);
      initRequestData = this.getAffiliateData(initRequestData);
      initRequestData.emailAndMobileSubscribed = true;
  
      return initRequestData;
    }
  getPNPThirdPartyLogin(userTxnId, callingFrom, triggerS2Scall?, txnAmount?,isNewUser=false, transactionStatuData=null) {
    if (userTxnId) {
      let loginData = {
        "txnId": userTxnId
      }
      this.emitterService.broadCastLogoutAndLoginStatus(true);
      this.pnpZimplerService.getPNPThirdPartyLogin(loginData).then(loginResponse => {
        if (loginResponse && loginResponse["status"] === "SUCCESS") {
          this.emitterService.broadCastLogoutAndLoginStatus('loggedin')
          if(isNewUser){
            this.policyService.updatePolocies(true);
          }else{
            this.policyService.checkPolociesInfo();
          }
          // this.isLoadingBrite = false;
          if(loginResponse && loginResponse["externalEcrId"]){
            localStorage.setItem('newUserZimpler', loginResponse["externalEcrId"]);  
          }
         
          if((transactionStatuData && transactionStatuData['txnStatus'] == "LOGIN_WITHOUT_DEPOSIT" || transactionStatuData['txnStatus'] == "CASHIER_TRANSFER_SUCCESS" || transactionStatuData['txnStatus'] == "DEPOSIT_SUCCESS") || environment.zimplerCountries.indexOf(this.countryIP) == -1){
            this.pnpThirdPartyLoginSuccesHanlder(loginResponse, callingFrom);
          }
          localStorage.setItem("gtmLoggedInEvent", "thirdPartyLogin");
          this.emitterService.broadCastDepositeSuccess(true)
          this.emitterService.broadcastLoginStatus(true)
          this.emitterService.broadcastloginComplete('true')
          this.emitterService.broadcastLoadHomeBanner(callingFrom == "login" ? "userLoggedInn" : "User_Data_Updated" );

          if(callingFrom === 'deposit' && triggerS2Scall) {
            // this.isToTriggerS2SForThirdPartyLogin = true;
            // this.s2sTxnAmount = txnAmount;
          }
         
        } else {
          this.pnpThirdPartyLoginFailHanlder(loginResponse, callingFrom);
        }
      });
    }
  }
  pnpThirdPartyLoginSuccesHanlder(response, callingFrom) {
    this.actionOnTransactionRedirection(txnState.SUCCESS_MESSAGE, 'zimpler.depositSuccessMsg', callingFrom)
  }
  actionOnTransactionRedirection(status, key, callingFrom?, step = 'step4', transactionInfo=null) {
    const message = this.translationService.instant(key);
    if(status == txnState.SUCCESS_MESSAGE && callingFrom == 'desposit'){
      let transactionData = {
        amount:transactionInfo?.amount, 
        currency:transactionInfo?.currency
      }
      let data = {message:message, page:'transaction-status-page',success:'notification',transactionData:transactionData}
      this.emitterService.broadCastTransactionStatus(data);
    }else if(status == txnState.SUCCESS_MESSAGE){
      let data = {message:message, page:'transaction-status-page',success:'login-success'}
      this.emitterService.broadCastTransactionStatus(data);
    }
    else{
      setTimeout(() => {
        let data = {message:message, page:'transaction-status-page',success:'failed'}
        this.emitterService.broadCastTransactionStatus(data);
      },1000);
    }
  }

  pnpThirdPartyLoginFailHanlder(response, callingFrom) {
    let message = '';
    let key = '';
    this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.deposit_LoginFailureMsg')
    // switch (callingFrom) {
    //   case 'login':
    //     this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.loginFailureMsg')
    //     break;
    //   case 'deposit':
    //     this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.deposit_LoginFailureMsg')
    //     break;
    //   case 'quick-registration':
    //     this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.quick_registration_LoginFailureMsg')
    //     break;
    //   default:
    //     this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.something_went_wrong')

    // }
  }

  navigateBasedOnTxStatus(transactionStatuData, txnId) {
    this.transactionId = txnId;
    let newUserEcrId = localStorage.getItem('newUserZimpler') ? localStorage.getItem('newUserZimpler') : ""; 
     const { status, txnStatus, externalEcrId, errorCode } = transactionStatuData;
     this.callHandlers(status,externalEcrId,transactionStatuData,txnStatus,errorCode,newUserEcrId)
   }
   callHandlers(status,externalEcrId,transactionStatuData,txnStatus,errorCode,newUserEcrId){
    localStorage.removeItem('newUserZimpler');
    
    if (status === 'SUCCESS') {
      if(this.utils.isUserLoggedIn() || (txnStatus == "LOGIN_WITHOUT_DEPOSIT" && status == "SUCCESS")){
        this.successTranctionHanlder(txnStatus, transactionStatuData);
      }else if(!this.userDetailsService.isRealUserAccount()){
        this.getPNPThirdPartyLogin(this.transactionId, 'deposit', '', '', !this.userDetailsService.isRealUser, transactionStatuData);
      }else{
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.something_went_wrong_redirection')
        return;
      } 
    }
    if (status === 'FAILURE' && errorCode === 100159) {
      sessionStorage.setItem("user","");
      this.failureTransactionHanlder(txnStatus, transactionStatuData);
    }
   }

   successTranctionHanlder(txnStatus, transactionStatuData) {

    this.userProfileDetails = this.userDetailsService.getUserProfileDetails();
    switch (txnStatus) {
      case 'DEPOSIT_SUCCESS':
      case 'CASHIER_TRANSFER_SUCCESS':
        this.pnpRegisterEvents(transactionStatuData)
        if (!sessionStorage.getItem("user")) {
          this.getPNPThirdPartyLogin(transactionStatuData['txnId'], 'deposit');
        } else {
          this.actionOnTransactionRedirection(txnState.SUCCESS_MESSAGE, 'zimpler.deposit_success_msg', 'desposit',transactionStatuData)
        }
        this.emitterService.broadcasttxnComplete("COMPLETED")
        break;
      case 'CASHIER_INIT_DEPOSIT_SUCCESS':
        if (!sessionStorage.getItem("user")) {
          this.getPNPThirdPartyLogin(transactionStatuData['txnId'], 'deposit', true, Number(transactionStatuData["amount"]).toFixed(2));
        } else {
          this.actionOnTransactionRedirection(txnState.SUCCESS_MESSAGE, 'zimpler.deposit_success_msg', 'deposit',transactionStatuData)
          this.pnpRegisterEvents(transactionStatuData)
        }
        break;
      case 'KYC_VERIFIED':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.kyc_verified_msg')
        break;
      case 'CASHIER_INIT_DEPOSIT_FAILED':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.cashier_init_deposit_failed')
        break;
      case 'LOGIN_WITHOUT_DEPOSIT':
        /**
         * Else condition encounter when user is already logged in with
         * DEMOUSER2 & try to deposit with DEMOUSER4 user
         * In general world on Production we don't encounter this case. 
         */
        if (!sessionStorage.getItem("user")) {
          this.getPNPThirdPartyLogin(transactionStatuData['txnId'], 'login', '', '', false, transactionStatuData);
        } else {
          this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.something_went_wrong')
        }
        break;
      case 'CATEGORY_LIMITS_EXCEEDED':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.CATEGORY_LIMITS_EXCEEDED')
        break;
      case 'DEPOSIT_NOT_ALLOWED':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.deposit_not_allowed')
        break;
      case 'RG_COOL_OFF':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.rg_cool_off')
        break;
    }
   
  }
  pnpRegisterEvents(transactionStatuData){
    this.utils.S2Scalls(this.userProfileDetails, "deposit", Number(transactionStatuData["amount"]).toFixed(2));
    this.utils.depositGTMevent("userDeposited", this.transactionId, transactionStatuData["externalEcrId"], parseInt(localStorage.getItem("pnpDepositedAmount")), localStorage.getItem("pnpDepositedCurrency"));
    if(!this.userDetailsService.isRealUserAccount()){
      this.utils.S2Scalls(this.userProfileDetails, "pnp");
      this.firstDepositUserEvent(transactionStatuData);
      let userData = localStorage.getItem('registerUserData') ? JSON.parse(localStorage.getItem('registerUserData')) : null;
      this.registerUserEvents(transactionStatuData,userData);
    }
  }
  failureTransactionHanlder(txnStatus, transactionStatuData) {
    switch (txnStatus) {
      case 'LOGIN_WITHOUT_DEPOSIT':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.login_without_depositFailureMsg')
        break;
      case 'DEPOSIT_SUCCESS':

        if (!sessionStorage.getItem("user")) {
          if (this.utils.getAffliateId('cvalue')) {
            sessionStorage.setItem("pnpUserDeposit", transactionStatuData["amount"]);
            sessionStorage.setItem("pnpUserCurrency", transactionStatuData["currency"] );
          }else{
            this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.something_went_wrong_redirection')
            return;
          }
        } else {
          this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.something_went_wrong')
        }
        break;
      case 'INIT':
      case 'KYC_VERIFIED':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.kyc_verified_msg')
        break; 
    }
  }
  registerUserEvents(data, userData?, reqRequestData?){
    if(environment.zimplerCountries.indexOf(this.countryIP)>=0  || environment.zimplerPnp.indexOf(this.countryIP)>=0){
      this.fullPnpGtmEvent(data)
   }
   this.utils.S2Scalls(reqRequestData, "pnp");
   this.userDetailsService.setSemiPnpUserData(null)
  }
  firstDepositUserEvent(data){
    this.utils.depositGTMevent("userFirstDeposit", this.transactionId, data["externalEcrId"], parseInt(data['amount']), data['currency']);
  }
  fullPnpGtmEvent(data){
    this.utils.gtmEvent("userRegistered", {
      emailId: this.transactionId + '@'+environment.website_name+'.com',
      userExternalECR: data["ecrExternalID"],
      username: this.transactionId + '@'+environment.website_name+'.com'
    });
  }
  
  setUserLanguage(reqRequestData) {
    if (this.countryIP == "FI") {
      reqRequestData["language"] = language["fi"];
    } else if (this.countryIP == "SE") {
      reqRequestData["language"] = language["en"];
    } else if (this.countryIP == "EE") {
      reqRequestData["language"] = language["et"];
    } else {
      reqRequestData["language"] = language[this.langCode];
    }
    return reqRequestData;
  }

  getAffiliateData(reqRequestData) {
    if (this.utils.getAffliateId("affiliatename")) {
      reqRequestData["affiliateName"] =
        this.utils.getAffliateId("affiliatename");
    }
    if (this.utils.getAffliateId("affiliate")) {
      reqRequestData["affiliateId"] = this.utils.getAffliateId("affiliate");
    }
    if (this.utils.getAffliateId("tracker")) {
      reqRequestData["trackerId"] = this.utils.getAffliateId("tracker");
    }
    if (this.utils.getAffliateId("cvalue")) {
      reqRequestData["bannerId"] = this.utils.getAffliateId("cvalue");
    }
    return reqRequestData;
  }
  getPNPUserFromTransaction(txnId) {
   this.transactionId = txnId;
    let transactionData = {
      "txnId": txnId
    }
    this.ajaxService.getPNPUserFromTransaction(transactionData).then(transactionStatuData => {
      this.handleRequestLooping(transactionStatuData,txnId);
    });
  }
  
  handleRequestLooping(transactionStatuData,txnId){
    let requestCounts = BRITEPLAY_REQUEST_MIN_LOOP_COUNT;
    this.transactionId = txnId;
    if (this.requestLoopCount < requestCounts && transactionStatuData &&
      (transactionStatuData['txnStatus'] === 'KYC_VERIFIED' || transactionStatuData['txnStatus'] === 'LOGIN_SUCCESS' || transactionStatuData['txnStatus'] === 'INIT' && transactionStatuData['status'] != "FAILURE")) {
          if((transactionStatuData['txnStatus'] === 'KYC_VERIFIED' || transactionStatuData['txnStatus'] === 'LOGIN_SUCCESS') && transactionStatuData['status'] == "SUCCESS" && transactionStatuData['externalEcrId'] && !this.isThirdPartyLoginCalled){
            if(!sessionStorage.getItem("user")) {
              this.getPNPThirdPartyLogin(this.transactionId, 'quick-registration', '', '', true, transactionStatuData);
            }
          }
        setTimeout(() => {
            this.requestLoopCount++;
            this.getPNPUserFromTransaction(txnId);
          }, 3000);       
    } else if((transactionStatuData['txnStatus'] === 'INIT' || transactionStatuData['txnStatus'] === 'LOGIN_WITHOUT_DEPOSIT') && transactionStatuData['status'] == "FAILURE"){
        if(transactionStatuData['errorCode'] == 100159 && !this.isUserLoggedIn ){
          if(this.requestCountForNewUser < 3){
            let self = this;
            setTimeout(() => {
              self.requestCountForNewUser++;
              self.getPNPUserFromTransaction(txnId);
            }, 3000);
          }else{
            this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.login_without_depositFailureMsg');
          }
        }else{
          // this.callingFrom = 'deposit';
          // this.depositAmount = 50;
          // this.backToCashier();
        }
         
    }else{
      this.requestLoopCount = 0;
      if (transactionStatuData) {
        localStorage.setItem("pnpDepositedAmount", transactionStatuData["amount"]);
        localStorage.setItem("pnpDepositedCurrency", transactionStatuData["currency"]);
        this.navigateBasedOnTxStatus(transactionStatuData, this.transactionId);
      }
    }
  }
  
  getRedirectionUrls(requestObj){
    requestObj['redirectURL'] = window.location.origin + "/redirection.html?transactionType=deposit",
    requestObj['successURL']  =  window.location.origin + "/redirection.html?transactionType=deposit",
    requestObj['failureURL']  = window.location.origin + "/redirection.html?transactionType=deposit"

    return requestObj
  }

  generateIframe(iframeUrl, isNewWindow){
    if(isNewWindow){
      let a = document.createElement("a");
      a.href =iframeUrl ;
      // a.target = "_blank";
      a.click();
      this.messageService.pendingNotification();
    }else{
      $("#payment-iframe-container").empty();
      let $iframe = $('<iframe src="' + iframeUrl + '" ></iframe>');
      $("#payment-iframe-container").append($iframe);
      this.emitterService.broadCastCashierLoader(false);
      this.emitterService.broadCastCustomCashierPage('i-frame-page');
    }
 
  }
  
}
